import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M28.1,16.6c-1.3,0.1-2.4,0.6-3.3,1.5c-0.6,0.6-0.9,1-1.7,2.6c-1.9,3.5-4,7.5-4.6,8.6l-0.2,0.4l-0.4,0
		c-0.2,0-0.6,0.1-0.9,0.2c-1.8,0.6-3.2,2.1-3.8,4c-0.1,0.3-0.5,3.3-1.2,9.5c0,0.1-0.1,1.1-0.3,2.2c-0.3,2.7-0.3,2.6-0.3,2.6
		c0.2,0,3.9,0.5,3.9,0.5c0,0,0,0.5-0.1,1c-0.4,3.4-0.5,3.8-0.4,4.2c0.1,0.6,0.2,1,0.4,1.5c0.5,1,1.6,1.7,2.6,1.9
		c0.2,0,0.3,0.1,0.3,0.1c0,0-2.3,0-5.1,0h-5l0,3.2l0,3.2h29h29l0-3.2l0-3.2h-2.7h-2.7l-0.2,0.7c-0.6,1.8-0.8,2.4-0.9,2.5
		c0,0-8.9,1.5-9.6,1.6c-0.1,0-0.7-0.7-2.1-2.4l-2-2.4l-13.6,0c-9,0-13.6,0-13.6-0.1c0,0,0-0.1,0.1-0.1c0.3,0,0.8-0.2,1.2-0.4
		c1.1-0.5,1.8-1.7,2-3.2c0.2-1.3,0.5-4.1,0.5-4.1c0-0.1,0.3-0.1,2.3,0.2c2.2,0.3,4.7,0.6,8.6,1.1c1.4,0.2,3.2,0.4,4,0.5
		c1.5,0.2,2.4,0.3,8.5,1.1c1.9,0.2,3.5,0.4,3.5,0.4c0,0,0,0.5-0.3,3c-0.2,2-0.3,2.3,0,3.1c0.3,1,0.9,1.8,1.8,2.2
		c0.7,0.4,1.2,0.5,2,0.4c1,0,1.7-0.3,2.4-1c0.4-0.4,0.4-0.5,0.6-0.9c0.3-0.6,0.4-1,0.7-3.4c0.2-1.3,0.3-2.4,0.3-2.4
		c0,0,3.3,0.4,3.8,0.4l0.2,0l0.2-1.7c0.1-0.9,0.3-2.4,0.4-3.2c0.1-0.8,0.3-2.9,0.5-4.5c0.2-1.6,0.4-3.3,0.4-3.7
		c0.1-0.9,0.1-2-0.1-2.7c-0.3-1.2-1-2.3-2-3.1c-0.5-0.4-1-0.7-1.4-0.8c-0.2-0.1-0.2-0.1-0.3-0.2c0-0.1-0.1-0.3-0.1-0.5
		c-0.1-0.2-0.7-2.7-1.4-5.5c-0.7-2.8-1.3-5.3-1.4-5.5c-0.5-1.6-1.6-2.8-3.2-3.4c-0.7-0.3-1.2-0.4-2.8-0.6c-0.8-0.1-3.2-0.4-5.4-0.7
		c-2.2-0.3-4.8-0.6-5.8-0.7c-1-0.1-2.3-0.3-2.9-0.4c-0.6-0.1-1.2-0.1-1.3-0.2c-0.1,0-0.7-0.1-1.3-0.2C29,16.5,28.9,16.5,28.1,16.6z
		 M32,20.8c3.9,0.5,7.2,0.9,8.1,1c0.4,0,1.4,0.2,2.2,0.3c0.8,0.1,2.5,0.3,3.6,0.4c4.5,0.5,5,0.6,5.3,0.7c0.4,0.1,0.8,0.5,1,0.9
		c0.3,0.5,0.2,0.4,1.6,6c0.7,3.2,0.8,3.6,0.9,3.7c0,0.1,0,0.2,0,0.2c0,0-3.3-0.4-3.6-0.4c-0.1,0-0.1-0.1-0.2-0.4
		c-0.2-0.7-0.6-1.4-1.2-1.8c-0.3-0.3-0.6-0.4-1-0.5c-0.4-0.1-7.2-1-7.8-1c-1.1,0-2.2,0.6-2.8,1.6c-0.1,0.2-0.2,0.4-0.2,0.4
		c0,0.1-0.5,0-3.6-0.4c-4.2-0.5-5.9-0.7-9.2-1.1c-1.4-0.2-2.6-0.3-2.6-0.3l-0.1,0l0.5-1c0.3-0.6,1-1.8,1.5-2.8c0.5-1,1-2,1.2-2.2
		c0.1-0.2,0.5-0.9,0.7-1.4c0.6-1.2,0.8-1.4,1.2-1.7c0.4-0.3,0.8-0.4,1.2-0.4C29,20.4,30.4,20.6,32,20.8z M21.8,34.2
		c1.1,0.4,1.9,1.3,2.2,2.5c0.1,0.5,0.1,1.3,0,1.8c-0.3,1.3-1.4,2.3-2.6,2.6c-0.5,0.1-1.3,0.1-1.8-0.1c-2.1-0.7-3.1-3.2-2-5.2
		c0.3-0.5,1-1.2,1.5-1.5c0.6-0.3,1-0.4,1.7-0.3C21.2,34.1,21.4,34.1,21.8,34.2z M55.9,38.4c0.8,0.3,1.3,0.7,1.8,1.4
		c0.4,0.6,0.6,1.2,0.6,1.9c0,0.8-0.2,1.4-0.6,2c-0.7,1-1.7,1.6-2.9,1.6c-1,0-1.8-0.3-2.5-1.1c-1.3-1.4-1.3-3.5,0-4.9
		c0.5-0.5,1-0.8,1.8-1.1C54.5,38.2,55.4,38.2,55.9,38.4z"
          fill={colourFill}
        />
        <path
          d="M44.3,23.9c-0.2,0.1-0.5,0.2-0.7,0.3c-1.9,1.3-1.7,4.2,0.4,5.2c1.1,0.5,2.4,0.3,3.3-0.6c0.6-0.6,0.9-1.3,0.9-2.1
		c0-1.3-0.9-2.5-2.2-2.9C45.4,23.8,44.7,23.8,44.3,23.9z"
          fill={colourFill}
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
